import MultiSelect from "@/components/multi-select"
import { type Id } from "@/models"
import { useCoreData } from "@/stores/coreDataStore"
import { computed } from "vue"
import { defineComponent, proxyProp, type ReactiveComponent } from "vue-utils"
import { useVtsLogStore } from "../store"

const SearchVtsLogFilters: ReactiveComponent = () => {
	const store = useVtsLogStore()
	const filter = proxyProp(() => store.requestOptions.filter)
	const coreData = useCoreData()

	const selectedFroms = computed(() => {
		const ids = new Set<Id>(filter.fromIds)
		return coreData.vtsCorrespondents.filter((c) => ids.has(c.id))
	})

	const selectedTos = computed(() => {
		const ids = new Set<Id>(filter.toIds)
		return coreData.vtsCorrespondents.filter((c) => ids.has(c.id))
	})

	return () => (
		<>
			<label>
				From
				<MultiSelect
					class="w-full"
					options={coreData.vtsCorrespondents}
					selected={selectedFroms.value}
					setSelected={(correspondents) => (filter.fromIds = correspondents.map((c) => c.id))}
					getKey={(c) => c.id}
					getText={(c) => c.name}
					allText="All Correspondents"
					noneText="All Correspondents"
					entityNames="VTS Correspondents"
				/>
			</label>
			<label>
				To
				<MultiSelect
					class="w-full"
					options={coreData.vtsCorrespondents}
					selected={selectedTos.value}
					setSelected={(correspondents) => (filter.toIds = correspondents.map((c) => c.id))}
					getKey={(c) => c.id}
					getText={(c) => c.name}
					allText="All Correspondents"
					noneText="All Correspondents"
					entityNames="VTS Correspondents"
				/>
			</label>
		</>
	)
}

export default defineComponent(SearchVtsLogFilters)
